<template>
  <z-dialogo
    ref="dialogo"
    titulo="Clientes"
    scrollable
    dividers
    no-padding
    largura="1000px"
    altura="383px"
  >
    <template v-slot:prepend>
      <v-toolbar flat color="white">
        <v-text-field
          ref="busca"
          v-model="busca"
          outlined
          filled
          single-line
          dense
          label="Pesquisar"
          clearable
          hide-details
          prepend-inner-icon="mdi-magnify"
          @keydown.enter="buscar"
          @focus="onBuscaFocus"
          @click:clear="limparBusca"
          @blur="is_busca_focused = false"
        ></v-text-field>
      </v-toolbar>
    </template>

    <template v-slot:conteudo>

      <v-card class="d-flex flex-column fill-height">
        <v-card-text class="pa-0 fill-height nice-scrollbar">
          <div ref="topo"></div>
          <v-data-table
            disable-pagination
            disable-sort
            hide-default-footer
            :headers="headers"
            :items="clientes"
            :loading="carregando"
          >

            <template v-slot:item="{ item: cliente, index }">
              <tr
                class="apontador noselect" 
                @click="selecionar(cliente)" 
              >
                <td>{{ cliente.id }}</td>
                <td>{{ cliente.razao }}</td>
                <td>{{ cliente.celular }}</td>
              </tr>
            </template>

          </v-data-table>
        </v-card-text>
      </v-card>
          
    </template>

    <template v-slot:actions_left>
      <span class="text-subtitle-2">Clientes encontrados: {{ clientes.length }}</span>
    </template>
    <template v-slot:actions_right>
      <v-btn depressed rounded color="primary" @click="fechar()">ESC - Fechar</v-btn>
    </template>
  </z-dialogo>
</template>

<script>
import clientesApi from "@/app/services/clientes";

export default {
  name: "DialogoBuscarCliente",

  data() {
    return {
      clientes: [],
      busca: '',
      headers: [
        { text: "Código", value: "id", width: "100px" },
        { text: "Razão Social", value: "razao" },
        { text: "Celular", value: "celular" },
      ],
      carregando: false,
      selectedItem: 0,
      grupoSelecionado: {}
    };
  },

  methods: {
    async abrir(search = '') {
      if (search) {
        this.busca = search;
        this.buscar();
      }

      this.$refs.dialogo.abrir();
      this.setFocus("busca", 300);
    },

    fechar() {
      this.$refs.dialogo.fechar();
    },

    async buscar(event) {
      try {
        if (event) {
          event.target.select();
        }

        this.carregando = true;
        this.clientes = await clientesApi.busca(this.busca);
      } catch (error) {
        this.$eventbus.erroSistema(error);
      } finally {
        this.carregando = false;
      }
    },

    selecionar(cliente) {
      this.$emit("selecionar", cliente);
      this.fechar();
    },

    onBuscaFocus(event) {
      console.log("onBuscaFocus");
      event.target.select(); 
      this.is_busca_focused = true;
    },

    limparBusca() {
      this.busca = "";
      this.clientes = [];
    },
  },
};
</script>

<style scoped></style>
